const escapeHtml = (value) =>
  String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");

export const brochureHTML = ({studentName = "there"}) => {
  const name = escapeHtml(studentName || "there");

  return `<!DOCTYPE html>
<html>
  <head>
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <style>
      body {
        margin: 0;
        padding: 0;
        background: #f0f1f5;
        -webkit-text-size-adjust: 100%;
        text-size-adjust: 100%;
      }
      table {
        border-collapse: collapse;
        mso-table-lspace: 0;
        mso-table-rspace: 0;
      }
      img {
        border: 0;
        display: block;
      }
      .email-shell {
        width: 600px;
        max-width: 600px;
        background: #ffffff;
        border-radius: 8px;
        overflow: hidden;
      }
      .serif {
        font-family: Georgia, "Times New Roman", serif;
      }
      .aleo {
        font-family: Aleo, Georgia, "Times New Roman", serif;
      }
      .nav {
        background: #2f3e4b;
      }
      .nav-image {
        width: 600px;
        max-width: 100%;
        height: auto;
      }
      .text-navy {
        color: #17304a;
      }
      .gold {
        color: #f6aa2a;
      }
      .intro-title {
        color: #17304a;
        font-family: Aleo, Georgia, "Times New Roman", serif;
        font-size: 32px;
        line-height: 1.08;
        text-align: center;
        font-weight: 400;
      }
      .body-copy {
        color: #000000;
        font-family: Georgia, "Times New Roman", serif;
        font-size: 21px;
        line-height: 1.35;
        text-align: center;
      }
      .panel {
        background: #2f3e4b;
        border-radius: 20px;
      }
      .panel-title {
        color: #ffffff;
        font-family: Georgia, "Times New Roman", serif;
        font-size: 32px;
        line-height: 1.14;
        font-weight: 700;
      }
      .panel-copy {
        color: #ffffff;
        font-family: Georgia, "Times New Roman", serif;
        font-size: 18px;
        line-height: 1.25;
        text-align: justify;
        font-weight: 700;
      }
      .panel-image {
        width: 219px;
        max-width: 100%;
        border-radius: 20px;
      }
      .button {
        background: #f6aa2a;
        border-radius: 24px;
        color: #ffffff;
        display: block;
        font-family: Aleo, Georgia, "Times New Roman", serif;
        font-size: 18px;
        font-weight: 700;
        line-height: 50px;
        text-align: center;
        text-decoration: none;
      }
      .action-title {
        color: #17304a;
        font-family: Aleo, Georgia, "Times New Roman", serif;
        font-size: 32px;
        line-height: 1.35;
        font-weight: 700;
      }
      .action-copy {
        color: #17304a;
        font-family: Georgia, "Times New Roman", serif;
        font-size: 20px;
        line-height: 1.35;
      }
      .trading-image {
        width: 259px;
        max-width: 100%;
        border-radius: 14px;
      }
      .support {
        background: #f0523d;
      }
      .support-title {
        color: #ffffff;
        font-family: Georgia, "Times New Roman", serif;
        font-size: 26px;
        line-height: 1.12;
        text-align: center;
        font-weight: 700;
      }
      .support-copy {
        color: #ffffff;
        font-family: Georgia, "Times New Roman", serif;
        font-size: 20px;
        line-height: 1.2;
        text-align: center;
        font-weight: 700;
      }
      .footer {
        background: #2f3e4b;
        color: #ffffff;
        font-family: Georgia, "Times New Roman", serif;
        font-size: 14px;
        line-height: 1.35;
        text-align: center;
        font-weight: 700;
      }
      @media only screen and (max-width: 620px) {
        .email-shell {
          width: 100% !important;
        }
        .nav-image {
          width: 100% !important;
        }
        .stack {
          display: block !important;
          width: 100% !important;
        }
        .panel-copy {
          text-align: left !important;
        }
        .mobile-center {
          text-align: center !important;
        }
      }
    </style>
  </head>
  <body>
    <table role="presentation" width="100%" bgcolor="#f0f1f5" cellpadding="0" cellspacing="0">
      <tr>
        <td align="center" style="padding: 4px 0 24px;">
          <table role="presentation" class="email-shell" width="600" cellpadding="0" cellspacing="0">
            <tr>
              <td class="nav">
                <img class="nav-image" src="cid:header.webp" width="600" alt="TPC Performance Centre - Learn. Trade. Earn." />
              </td>
            </tr>
            <tr>
              <td style="padding: 60px 24px 34px;">
                <div class="intro-title">
                  Hey, ${name}!<br />
                  Here is your brochure for
                  <span class="gold" style="font-style: italic;">Price Action Trader Bootcamp.</span>
                  Thank you for your interest.
                </div>
              </td>
            </tr>
            <tr>
              <td style="padding: 0 24px;">
                <div style="height: 1px; background: #f6aa2a; line-height: 1px;">&nbsp;</div>
              </td>
            </tr>
            <tr>
              <td style="padding: 60px 26px 42px;">
                <div class="body-copy">
                  We&rsquo;re excited to share more about a programme designed to help
                  you build real skills, gain confidence, and take a practical step
                  toward your future.
                  <br /><br />
                  Your brochure gives you a clear overview of what the programme
                  covers, how the learning journey works, and what you can expect
                  as you move through the course.It&rsquo;s the perfect place to start
                  if you&rsquo;re exploring whether this programme is the right fit for
                  your goals.
                </div>
              </td>
            </tr>
            <tr>
              <td style="padding: 24px 24px 58px;">
                <table role="presentation" class="panel" width="100%" cellpadding="0" cellspacing="0">
                  <tr>
                    <td style="padding: 48px 28px;">
                      <table role="presentation" width="100%" cellpadding="0" cellspacing="0">
                        <tr>
                          <td class="stack" width="50%" valign="top">
                            <div class="panel-title">
                              Want to talk<br />
                              to a trade<br />
                              professional?
                            </div>
                            <div style="height: 40px; line-height: 40px;">&nbsp;</div>
                            <div class="panel-copy">
                              Still have questions or want to speak to someone first?
                              No problem. You can <span class="gold">book a consultation</span>
                              with our team, and we&rsquo;ll walk you through the
                              programme, payment options, learning structure, and
                              anything else you&rsquo;d like to know.
                            </div>
                          </td>
                          <td class="stack" width="50%" valign="top" align="right">
                            <img class="panel-image" src="cid:consultation.webp" width="219" alt="Trading consultation" />
                            <div style="height: 18px; line-height: 18px;">&nbsp;</div>
                            <a class="button" href="https://calendly.com/conrad-tpc/30min?month=2026-06" target="_blank" rel="noopener noreferrer" style="width: 230px; max-width: 100%; border-radius: 18px; font-size: 15px; line-height: 18px; padding: 13px 0; white-space: nowrap;">
                              Book my consultation now
                            </a>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td style="padding: 0 38px 62px;">
                <div class="body-copy">
                  Choosing the right programme is a big step, and we&rsquo;re here to
                  make it easier. Our team is ready to support you, answer your
                  questions, and help you move forward with confidence.
                </div>
              </td>
            </tr>
            <tr>
              <td style="height: 28px; background: #f0f1f5; line-height: 28px;">&nbsp;</td>
            </tr>
            <tr>
              <td style="padding: 56px 20px 48px;">
                <table role="presentation" width="100%" cellpadding="0" cellspacing="0">
                  <tr>
                    <td class="stack" width="48%" valign="top">
                      <img class="trading-image" src="cid:trading-laptop.webp" width="259" alt="Price action trading chart" />
                    </td>
                    <td class="stack" width="52%" valign="top" style="padding-left: 16px;">
                      <div class="action-title">
                        Turn your <span class="gold" style="font-style: italic;">interest</span><br />
                        into <span class="gold" style="font-style: italic;">action</span>
                      </div>
                      <div style="height: 20px; line-height: 20px;">&nbsp;</div>
                      <div class="action-copy">
                        This could be the opportunity that moves you from thinking
                        about your future to actively building it. If you&rsquo;re ready
                        to take the next step, sign up and begin your learning
                        journey with TPC.
                      </div>
                    </td>
                  </tr>
                </table>
                <table role="presentation" width="100%" cellpadding="0" cellspacing="0">
                  <tr>
                    <td align="center" style="padding-top: 28px;">
                      <a class="button" href="https://andus.co.za/trade-register" target="_blank" rel="noopener noreferrer" style="width: 300px;">
                        Sign me up!
                      </a>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td class="support" style="padding: 56px 44px 58px;">
                <div class="support-title">
                  We&rsquo;re thrilled to be part of your learning journey and can&rsquo;t
                  wait to see you grow, develop and move forward
                  <span style="font-style: italic;">with confidence.</span>
                </div>
                <div style="height: 24px; line-height: 24px;">&nbsp;</div>
                <div class="support-copy">
                  If you have any questions, please contact us &mdash; our team is
                  here to support you every step of the way.
                </div>
              </td>
            </tr>
            <tr>
              <td style="height: 100px; line-height: 100px;">&nbsp;</td>
            </tr>
            <tr>
              <td class="footer" style="padding: 42px 32px;">
                &copy; 2026 Trade Performance Centre. All rights reserved.<br />
                You&rsquo;re receiving this email because you signed up for a programme on
                tradeperformancecentre.com.
                <br /><br />
                Floor 2, Landmark Building, 13 Umgazi Rd, Menlo Park, Pretoria, 0081
                <br /><br />
                Contact us: 012 051 3483 | Enquiries: registrations@tpc.training
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  </body>
</html>`;
};
